// src/constants/chocoboConstants.js

export const CHOCOBO_BEHAVIORS = {
    DISCIPLINED: {
      id: 1,
      improvement_factor: 10,
      description: "Follows commands perfectly, maintains steady pace"
    },
    SPIRITED: {
      id: 2,
      improvement_factor: 9,
      description: "Energetic and eager, occasionally overexcited"
    },
    STEADY: {
      id: 3,
      improvement_factor: 7,
      description: "Reliable and consistent, but not exceptional"
    },
    CAUTIOUS: {
      id: 4,
      improvement_factor: 6,
      description: "Safe but slower, hesitates at obstacles"
    },
    STUBBORN: {
      id: 5,
      improvement_factor: 4,
      description: "Requires extra motivation, may ignore commands"
    },
    SKITTISH: {
      id: 6,
      improvement_factor: 3,
      description: "Easily spooked, unpredictable energy bursts"
    },
    REBELLIOUS: {
      id: 7,
      improvement_factor: 2,
      description: "Frequently disobeys, attempts to throw rider"
    },
    FERAL: {
      id: 8,
      improvement_factor: 1,
      description: "Uncontrollable, dangerous to ride, high risk"
    }
}

export const CHOCOBO_BASE_STATS={
    "yellow": {
      "region1": {
        "base_speed": 49,
        "base_stamina": 52,
        "base_behaviour": 3,
        "xfactor_percentage": 1
      },
      "region2": {
        "base_speed": 65,
        "base_stamina": 55,
        "base_behaviour": 4,
        "xfactor_percentage": 1
      },
      "region3": {
        "base_speed": 48,
        "base_stamina": 46,
        "base_behaviour": 6,
        "xfactor_percentage": 3
      },
      "region4": {
        "base_speed": 45,
        "base_stamina": 65,
        "base_behaviour": 7,
        "xfactor_percentage": 15
      },
      "region5": {
        "base_speed": 85,
        "base_stamina": 35,
        "base_behaviour": 3,
        "xfactor_percentage": 1
      },
      "region6": {
        "base_speed": 65,
        "base_stamina": 94,
        "base_behaviour": 2,
        "xfactor_percentage": 1
      },
      "region7": {
        "base_speed": 69,
        "base_stamina": 78,
        "base_behaviour": 1,
        "xfactor_percentage": 9
      }
    },
    "pink": {
      "region2": {
        "base_speed": 39,
        "base_stamina": 47,
        "base_behaviour": 3,
        "xfactor_percentage": 4
      },
      "region3": {
        "base_speed": 59,
        "base_stamina": 45,
        "base_behaviour": 7,
        "xfactor_percentage": 2
      },
      "region4": {
        "base_speed": 94,
        "base_stamina": 87,
        "base_behaviour": 7,
        "xfactor_percentage": 19
      },
      "region7": {
        "base_speed": 94,
        "base_stamina": 84,
        "base_behaviour": 2,
        "xfactor_percentage": 2
      }
    },
    "black": {
      "region1": {
        "base_speed": 59,
        "base_stamina": 59,
        "base_behaviour": 2,
        "xfactor_percentage": 1
      },
      "region2": {
        "base_speed": 39,
        "base_stamina": 47,
        "base_behaviour": 3,
        "xfactor_percentage": 4
      },
      "region3": {
        "base_speed": 59,
        "base_stamina": 45,
        "base_behaviour": 3,
        "xfactor_percentage": 2
      },
      "region4": {
        "base_speed": 94,
        "base_stamina": 87,
        "base_behaviour": 4,
        "xfactor_percentage": 2
      },
      "region7": {
        "base_speed": 94,
        "base_stamina": 87,
        "base_behaviour": 1,
        "xfactor_percentage": 1
      }
    },
    "gold": {
      "region7": {
        "base_speed": 99,
        "base_stamina": 99,
        "base_behaviour": 1,
        "xfactor_percentage": 25
      }
    },
    "blue": {
      "region2": {
        "base_speed": 39,
        "base_stamina": 47,
        "base_behaviour": 3,
        "xfactor_percentage": 4
      },
      "region4": {
        "base_speed": 94,
        "base_stamina": 87,
        "base_behaviour": 8,
        "xfactor_percentage": 19
      },
      "region7": {
        "base_speed": 94,
        "base_stamina": 87,
        "base_behaviour": 1,
        "xfactor_percentage": 19
      }
    },
    "green": {
      "region1": {
        "base_speed": 59,
        "base_stamina": 59,
        "base_behaviour": 2,
        "xfactor_percentage": 1
      },
      "region3": {
        "base_speed": 59,
        "base_stamina": 45,
        "base_behaviour": 1,
        "xfactor_percentage": 2
      },
      "region4": {
        "base_speed": 59,
        "base_stamina": 45,
        "base_behaviour": 1,
        "xfactor_percentage": 2
      },
      "region6": {
        "base_speed": 25,
        "base_stamina": 89,
        "base_behaviour": 2,
        "xfactor_percentage": 1
      },
      "region7": {
        "base_speed": 59,
        "base_stamina": 45,
        "base_behaviour": 1,
        "xfactor_percentage": 2
      }
    },
    "white": {
      "region6": {
        "base_speed": 89,
        "base_stamina": 90,
        "base_behaviour": 4,
        "xfactor_percentage": 39
      },
      "region7": {
        "base_speed": 59,
        "base_stamina": 45,
        "base_behaviour": 1,
        "xfactor_percentage": 2
      }
    },
    "red": {
      "region6": {
        "base_speed": 92,
        "base_stamina": 89,
        "base_behaviour": 8,
        "xfactor_percentage": 39
      },
      "region7": {
        "base_speed": 59,
        "base_stamina": 45,
        "base_behaviour": 1,
        "xfactor_percentage": 2
      }
    }
  }
